import { ProgressBar } from '@sl/react-datafabric-components';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AgentNewsDocument } from '../../app/home/ghostnews/agent.interface';
import { useAgentContext } from '../context/agent.provider';

interface AgentStatusGuardProps {
  children: React.ReactNode;
  allowedStatuses?: AgentNewsDocument['status'][];
}

/**
 * AgentStatusGuard component protects routes that require an active agent.
 * It checks if the current agent's status matches the allowed statuses (defaults to ['active']).
 * If status check fails, redirects to:
 * - /no-access if agent is inactive
 * - /news-agents/new if no agent exists or if agent setup is incomplete
 */

export const AgentStatusGuard: React.FC<AgentStatusGuardProps> = ({
  children,
  allowedStatuses = ['active', 'paused'] as AgentNewsDocument['status'][],
}) => {
  const { currentAgent, loadingAgent } = useAgentContext();
  const location = useLocation();

  if (loadingAgent) {
    return <ProgressBar />;
  }

  // Check if current agent status is allowed
  const isStatusAllowed = allowedStatuses.includes(currentAgent?.status);

  // const inactiveStatuses: AgentNewsDocument['status'][] = [
  //   'inactive',
  //   'canceled',
  // ];
  // const newPath = inactiveStatuses.includes(currentAgent?.status)
  //   ? '/no-access'
  //   : '/news-agents/new';

  const newPath = '/news-agents/new';

  if (!currentAgent || !isStatusAllowed) {
    // Redirect to no access page
    return <Navigate to={newPath} replace state={{ from: location }} />;
  }

  return <>{children}</>;
};
